import { ImageResolution } from 'helpers';
import { DownloadInitiator } from 'services/tracking/download-initiator';

export interface DownloadSelection {
    images: boolean;
    video: boolean;
    productAttributes: boolean;
    resolution: ImageResolution | null;
    csvLanguage: string | null;
}

export interface BulkDownloadContext {
    type: 'bulk';
    gtins?: string[];
    articleNumbers?: string[];
    initiator: DownloadInitiator;
}

export interface OrderDownloadContext {
    type: 'order';
    orderId: string;
    orderType: string;
    initiator: DownloadInitiator;
}

export interface SummaryBarDownloadContext {
    type: 'summaryBar';
    initiator: DownloadInitiator;
}

export interface LightboxDownloadContext {
    type: 'lightbox';
    gtin: string;
    fileId: string;
    initiator: DownloadInitiator;
}

export type DownloadSelectionContext =
    | BulkDownloadContext
    | OrderDownloadContext
    | SummaryBarDownloadContext
    | LightboxDownloadContext;

export const DEFAULT_DOWNLOAD_SELECTION: DownloadSelection = {
    images: true,
    video: false,
    productAttributes: false,
    resolution: ImageResolution.Original,
    csvLanguage: 'preferredLanguage'
};

export interface DownloadSelectionMetadata {
    imageCount?: number;
    videoCount?: number;
}
